module.exports = __webpack_public_path__ + "media/images/logo-877e5939d0778dffcb4bfcd79b31f135.svg";